module.exports = __webpack_public_path__ + "static/media/lto-promo-image.6407e4a6.png";